// App.js - Componente principal refactorizado con localStorage
import React, { useState, useEffect } from 'react';
import { ThemeProvider, createTheme, CssBaseline, Box, Typography } from '@mui/material';
import LoginForm from './components/LoginForm';
import Navigation from './components/Navigation';
import ClientesTab from './components/ClientesTab';
import HistoricoTab from './components/HistoricoTab';
import CalculatorForm from './components/calculator/CalculatorForm';
import PlantillasTab from './components/PlantillasTab';

// Tema personalizado
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// Credenciales hardcodeadas
export const CREDENTIALS = {
  username: 'admin',
  password: 'Ad*2025'
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  // Verificar si hay una sesión guardada al cargar la aplicación
  useEffect(() => {
    console.log('Verificando sesión guardada...'); // Debug
    const savedSession = localStorage.getItem('sistemaAumentosSession');
    
    if (savedSession) {
      console.log('Sesión encontrada:', savedSession); // Debug
      try {
        const sessionData = JSON.parse(savedSession);
        const currentTime = new Date().getTime();
        
        console.log('Tiempo actual:', currentTime); // Debug
        console.log('Expira en:', sessionData.expiry); // Debug
        
        // Verificar si la sesión no ha expirado (24 horas por defecto)
        if (sessionData.expiry && currentTime < sessionData.expiry) {
          console.log('Sesión válida, iniciando automáticamente...'); // Debug
          setIsAuthenticated(true);
        } else {
          console.log('Sesión expirada, limpiando...'); // Debug
          // Si la sesión expiró, limpiar localStorage
          localStorage.removeItem('sistemaAumentosSession');
        }
      } catch (error) {
        console.error('Error al recuperar la sesión:', error);
        localStorage.removeItem('sistemaAumentosSession');
      }
    } else {
      console.log('No hay sesión guardada'); // Debug
    }
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    // Limpiar localStorage al cerrar sesión
    localStorage.removeItem('sistemaAumentosSession');
    setIsAuthenticated(false);
    setActiveTab(0);
  };

  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
  };

  // Renderizado principal
  if (!isAuthenticated) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LoginForm onLogin={handleLogin} />
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ flexGrow: 1 }}>
        <Navigation 
          activeTab={activeTab} 
          onTabChange={handleTabChange} 
          onLogout={handleLogout} 
        />
        
        {activeTab === 0 && <ClientesTab />}
        {activeTab === 1 && <HistoricoTab />}
        {activeTab === 2 && <CalculatorForm />}
        {activeTab === 3 && <PlantillasTab />}
      </Box>
      <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 4, mb: 2 }}>
        {'© '}
        www.amigodigital.com.ar {new Date().getFullYear()} - Versión 1.4.2
        {'.'}
      </Typography>
    </ThemeProvider>
  );
}

export default App;